<template>
  <div class="flex items-start justify-between gap-3 py-2 border-b last:border-b-0 border-slate-100 dark:border-slate-800">
    <span class="text-xs text-slate-500 dark:text-slate-400">{{ label }}</span>
    <span class="text-sm text-right break-words text-slate-900 dark:text-white" :class="valueClass">
      {{ safeValue }}
    </span>
  </div>
</template>

<script>
export default {
  name: "ProfileRow",
  props: {
    label: String,
    value: [String, Number],
    valueClass: { type: String, default: "" },
  },
  computed: {
    safeValue() {
      return this.value === null || this.value === undefined || this.value === ""
        ? "-"
        : this.value;
    },
  },
};
</script>
